import { nanoid } from "@reduxjs/toolkit";
import React, { ChangeEventHandler, useEffect, useMemo, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import Option from "../components/Option";
import { SalesPerformanceList, SalesPerformanceType } from "../components/commonWidget";
import chartIcon from "../components/custom/assets/images/dashboard/chart_icon.svg";
import tableIcon from "../components/custom/assets/images/dashboard/table_icon.svg";
import FormInput2 from "../components/custom/components/FormInput2";
import {
  Tbody,
  Thead,
} from "../components/custom/components/TradeCategoryPerformanceTable";
import TransactionTable from "../components/custom/components/TransactionTable";
import LineChart from "../components/custom/components/charts/apex/LineChart";
import { COLORS } from "../components/custom/constants";
import UserLayout from "../components/custom/layouts/UserLayout";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";
import { defaultLocation, defaultPortfolio, DropDownOption1, PAGE_SIZE } from "../config";
import api, { APIResponse, getAxiosRequestConfig } from "../config/api";
import {
  CSVdownload,
  YearOptions,
  handleDownloadPDF,
} from "../config/functions";
import { AuthUserType } from "../redux/actions/authUserActions";
import { BrandType } from "../redux/actions/brandActions";
import { BrandCompanyType } from "../redux/actions/brandCompanyActions";
import { PortfolioType } from "../redux/actions/portfolioActions";
import {
  OptionsTypes,
  addToSelectedOption,
} from "../redux/actions/selectedOptionsActions";
import { SiteType } from "../redux/actions/siteActions";
import { TradeSubCategoryType } from "../redux/actions/tradeSubCategoryActions";
import { StoreState } from "../redux/store";

import { CatSubCatCompanyWithBrandRelationDataType } from "./TransactionBillWiseReport";
import Loader from "../components/custom/components/Loader";
import Modal from "../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowMaximize } from "@fortawesome/free-solid-svg-icons";
import { areaType } from "../redux/actions/areaActions";
import { outletType } from "../redux/actions/outletActions";
import { useLocation } from "react-router-dom";
import { UserLog } from "../config/common";
import SingleSelect from "../components/custom/components/SingleSelect";
import SingleSelect1 from "../components/custom/components/SingleSelect1";

export interface DropDownOption {
  value: number;
  label: string;
  imgUrl: string;
}

export interface YearlyFootfallDailyFlowRecord {
  centerid: number;
  buildingid: number;
  floorid?: number;
  transyear: number;
  tcount: string;
}

export interface YearlyFootfallDailyFlowReportType {
  portfolio: number;
  record: YearlyFootfallDailyFlowRecord[];
  count?: number;
}

export interface MonthlyFootfallDailyFlowRecord {
  centerid: number;
  floorid?: number;
  buildingid: number;
  date: string;
  transyear: number;
  transmonth: number;
  tcount: string;
}

export interface MonthlyFootfallDailyFlowReportType {
  portfolio: number;
  record: MonthlyFootfallDailyFlowRecord[];
  count?: number;
}

const FootfallDailyFlowReport: React.FC = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const pageName = useLocation()
  const authUser = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  );
  const authUserToken = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  )?.["auth-token"]!;
  const config = getAxiosRequestConfig(authUserToken);

  const authUserSiteId = authUser?.siteId;

  const portfolioOption = useSelector<StoreState, PortfolioType[]>(
    (state) => state?.portfolio
  );
  const siteOption = useSelector<StoreState, SiteType[]>(
    (state) => state?.site
  );
  const brandOption = useSelector<StoreState, BrandType[]>(
    (state) => state?.brand
  );
  const brandCompanyOption = useSelector<StoreState, BrandCompanyType[]>(
    (state) => state?.brandCompany
  );

  const selectedOption = useSelector<StoreState, OptionsTypes>(
    (state) => state?.selectedOption
  );
  const outletList = useSelector<StoreState, outletType[]>(
    (state) => state?.outlet
  );
  
  const localityOption = useSelector<StoreState, areaType[]>(
    (state) => state?.locality
  );
  const port =
    authUser?.portfolioId !== undefined && authUser?.portfolioId !== null
      ? authUser?.portfolioId?.split(",")
      : [];

  let portfolioData = port
    ?.map((pe) => {
      return portfolioOption?.filter(
        (f) => f?.id?.toString() === pe?.toString()
      );
    })
    ?.flat(1);

  const pname = portfolioData[0]?.name;

  const st =
    authUser?.siteId !== undefined && authUser?.siteId !== null
      ? authUser?.siteId?.split(",")
      : [];

  let siteData = st
    ?.map((pe) => {
      return siteOption?.filter((f) => f?.id?.toString() === pe?.toString());
    })
    ?.flat(1);


  const [
    catSubCatCompanyWithBrandRelationData,
    setCatSubCatCompanyWithBrandRelationData,
  ] = useState<CatSubCatCompanyWithBrandRelationDataType[]>([]);


  const [valueIn, setValueIn] = useState<string>("");

  const [portfolios, setPortfolios] = useState<string>("");
  const [sites, setSites] = useState<string>("");
  const [brands, setBrands] = useState<string>("");

  const [location, setLocation] = useState<string>("");
  const [categories, setCategories] = useState<string>("");
  const [subCategories, setSubCategories] = useState<string>("");
  const [selection, setSelection] = useState<SalesPerformanceType>(
    SalesPerformanceList?.MONTHLY
  );

  //loader
  const [fileLoader, setFileLoader] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [pag, setPag] = useState<boolean>(false);

  const [monthlyFootfallDailyFlowData, setMonthlyFootfallDailyFlowData] =
    useState<MonthlyFootfallDailyFlowReportType[]>([]);
  const [yearlyFootfallDailyFlowData, setYearlyFootfallDailyFlowData] =
    useState<YearlyFootfallDailyFlowReportType[]>([]);
  const [yearAndMonth, setYearAndMonth] = useState<Date>(new Date());
  const [year, setYear] = useState<Date>(new Date());
  const [condition,setCondition] = useState<boolean>(false)
  const month = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const days = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
  ];

  const limit = PAGE_SIZE + 50;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(50);
  const [yearDropDown, setYearDropDown] = useState<number[]>(YearOptions());
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [disableLocality, setDisableLocality] = useState<boolean>(false);

  const [portfolioDrop, setPortfolioDrop] = useState<DropDownOption[]>([]);
  const [locationDrop, setLocationDrop] = useState<DropDownOption[]>([]);

  const showExpandModalHandler = () => {
    setShowModal(true)
  };

  const handleSelectedRowsChange = (selectedRows: string[]) => {
    setSelectedRows(selectedRows);
  };

  
  const handleOff = (conditionVal: boolean) => {
    setCondition(conditionVal);
  };



  const SiteFilteredByPortfolio = useMemo<SiteType[]>(() => {
    if (portfolios !== "") {
      return siteData?.filter((s) => {
        return s?.pfid?.toString() === portfolios?.toString();
      });
    } else return [];
  }, [portfolios, siteData]);

  const monthlyHandler = () => {
    setSelection(SalesPerformanceList?.MONTHLY);
    setPag(false)
  };

  const yearlyHandler = () => {
    setSelection(SalesPerformanceList?.YEARLY);
    setPag(false)
  };

  useEffect(() => {
    if (portfolios !== "") {
      handleApply();
    }
  }, [selection]);

  const handleDateChange = (date:any) => {
    setYearAndMonth(date);
    setPag(false);
  };

const handlePortfolioDrop = (selected: any) => {
  if(selected.length>0){
    const selectedPortfolio = selected as DropDownOption[];
    if(selectedPortfolio[0].value!==null&&selectedPortfolio[0].value!==0){
      setPortfolioDrop(selectedPortfolio)
      setPortfolios(selectedPortfolio[0]?.value?.toString())
      const data = { ...selectedOption, portfolio: selectedPortfolio[0]?.value?.toString() };
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false)
    }
}
};

const handleClearPortfolio = () =>{
  let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
  setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
  const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
  if (b?.length > 0 && b[0]?.id !== undefined) {
    const val: DropDownOption = {
      value: b[0]?.id, 
      label: b[0]?.name,
      imgUrl: b[0]?.logourl, 
    };
    setPortfolioDrop([val]);
    setLocation("");
    setLocationDrop([])
    const data = { ...selectedOption, portfolio: b[0]?.id?.toString(),location:''};
    dispatch(addToSelectedOption(data));
    setOffset(0);
    setPag(false);
}
}


const handleLocationDrop = (selected: any) => {
  if(selected.length>0){
    const selectedLocation = selected as DropDownOption[];
    if(selectedLocation[0].value!==null&&selectedLocation[0].value!==0){
      setLocationDrop(selectedLocation)
      setLocation(selectedLocation[0]?.label?.toString())
     const data = { ...selectedOption,location: selectedLocation[0]?.label?.toString()};
     dispatch(addToSelectedOption(data));
     setOffset(0);
     setPag(false)
    }
  }
};

const handleClearLocation = () =>{
     setLocationDrop([])
     setLocation('')
     const data = { ...selectedOption,location: ""};
     dispatch(addToSelectedOption(data));
     setOffset(0);
     setPag(false)
}

  
  const portFilter = portfolioOption?.filter((a)=>a?.id?.toString()===portfolios?.toString())
  const localityFilter = localityOption?.filter((a)=>a?.area?.toString()===location?.toString())


  const combinedValues = [
    ...portFilter?.map(a => `Portfolio: ${a?.name}`),            
    ...localityFilter?.map(f=>`Locality: ${f?.area}`),     
    `Year: ${yearAndMonth?.getFullYear()}, Month: ${yearAndMonth?.getMonth()+1}`,
  ]
  ?.filter(name => name && name?.trim() !== '') 
  ?.join(', ');  
  

  const tHead = useMemo<Thead[]>(() => {
    var theadArray: {
      id: string;
      children: string;
      text: string;
    }[] = [
      { id: "Center", children: "Center", text: "Center" },
      { id: "Building", children: "Building", text: "Building" },
      { id: "Date", children: "Date", text: "Date" },
      { id: "Count", children: "Count", text: "Count" },
    ];

    return theadArray;
  }, []);

  const tHead1 = useMemo<Thead[]>(() => {
    var theadArray: {
      id: string;
      children: string;
      text: string;
    }[] = [
      { id: "Center", children: "Center", text: "Center" },
      { id: "Building", children: "Building", text: "Building" },
      { id: "Year", children: "Year", text: "Year" },
      { id: "Count", children: "Count", text: "Count" },
    ];

    return theadArray;
  }, []);

  const fetchDataForDownload = async () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    }
    if (selection === SalesPerformanceList?.MONTHLY) {
      if (
        yearAndMonth === null ||
        (yearAndMonth !== null &&
          yearAndMonth?.getFullYear()?.toString() === "" &&
          yearAndMonth?.getMonth()?.toString() === "")
      ) {
        toast("Select month and year", ToastTypes?.ERROR);
        error = true;
      }
    }

    const yr = yearAndMonth?.getFullYear();
    const mon = month[yearAndMonth?.getMonth()];

    var MgetData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: yr,
      month: mon,
      limit: limit?.toString(),
      offset: offset?.toString(),
    };
    // } else {
    var YgetData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      limit: limit?.toString(),
      offset: offset?.toString(),
    };

    if (error === false && MgetData !== undefined) {
      if (selection === SalesPerformanceList?.MONTHLY) {
        const response = await api.post<
          APIResponse<{ records: MonthlyFootfallDailyFlowReportType[] }>
        >(`kpi/footfall/monthwiseDailyFlow`, MgetData, config);

        if (response?.status === 200 && response?.data?.data) {
          return response?.data?.data?.records;
        }
      } else if (selection === SalesPerformanceList?.YEARLY) {
        const response = await api.post<
          APIResponse<{ records: YearlyFootfallDailyFlowReportType[] }>
        >(`kpi/footfall/yearwiseDailyFlow`, YgetData, config);

        if (response?.status === 200 && response?.data?.data) {
          return response?.data?.data?.records;
        }
      }
    }

    return [];
  };

  const getMonthlyDownloadData = (
    Data: MonthlyFootfallDailyFlowReportType[]
  ) => {
    var tableHead: Thead[] = [
      { id: "Center", children: "Center", text: "Center" },
      // { id: "Building", children: "Building", text: "Building" },
      { id: "Date", children: "Date", text: "Date" },
      { id: "Count", children: "Count", text: "Count" },
    ];
    var tableBody: Tbody[][] = [];

    Data?.forEach((d, i) => {
      siteOption
        ?.filter((ss) => ss?.pfid?.toString() === d?.portfolio?.toString())
        ?.forEach((s) => {
          d?.record
            ?.filter((r) => r?.centerid?.toString() === s?.id?.toString())
            ?.forEach((item) => {
              const centerObj = siteOption?.find(
                (s) => s?.id?.toString() === item?.centerid?.toString()
              );
              var tBody: Tbody[] = [];
              tBody?.push(
                {
                  id: nanoid(),
                  theadId: "Center",
                  children: centerObj?.name,
                  text: centerObj?.name,
                },
                // {
                //   id: nanoid(),
                //   theadId: "Building",
                //   children: buildingObj?.buildingname,
                //   text: buildingObj?.buildingname,
                // },
                {
                  id: nanoid(),
                  theadId: "Date",
                  children: item?.date,
                  text: item?.date?.toString(),
                },
                {
                  id: nanoid(),
                  theadId: "Count",
                  children: item?.tcount,
                  text: item?.tcount?.toString(),
                }
              );
              tableBody?.push(tBody);
            });
        });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  const getYearlyDownloadData = (Data: YearlyFootfallDailyFlowReportType[]) => {
    var tableHead: Thead[] = [
      { id: "Center", children: "Center", text: "Center" },
      // { id: "Building", children: "Building", text: "Building" },
      { id: "Year", children: "Year", text: "Year" },
      { id: "Count", children: "Count", text: "Count" },
    ];
    var tableBody: Tbody[][] = [];

    Data?.forEach((d, i) => {
      siteOption
        ?.filter((ss) => ss?.pfid?.toString() === d?.portfolio?.toString())
        ?.forEach((s) => {
          d?.record
            ?.filter((r) => r?.centerid?.toString() === s?.id?.toString())
            ?.forEach((item) => {
              const centerObj = siteOption?.find(
                (s) => s?.id?.toString() === item?.centerid?.toString()
              );
              // const buildingObj = buildingOption?.find(
              //   (b) =>
              //     b?.buildingid?.toString() === item?.buildingid?.toString()
              // );
              var tBody: Tbody[] = [];
              tBody?.push(
                {
                  id: nanoid(),
                  theadId: "Center",
                  children: centerObj?.name,
                  text: centerObj?.name,
                },
                // {
                //   id: nanoid(),
                //   theadId: "Building",
                //   children: buildingObj?.buildingname,
                //   text: buildingObj?.buildingname,
                // },
                {
                  id: nanoid(),
                  theadId: "Year",
                  children: item?.transyear,
                  text: item?.transyear?.toString(),
                },
                {
                  id: nanoid(),
                  theadId: "Count",
                  children: item?.tcount,
                  text: item?.tcount?.toString(),
                }
              );
              tableBody?.push(tBody);
            });
        });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  useEffect(() => {
    if (selection === SalesPerformanceList?.MONTHLY) {
      const header = tHead
        ?.map((a) => a?.text)
        ?.filter(
          (id): id is string => typeof id === "string" && id !== undefined
        );
      setSelectedRows(header);
    }
    if (selection === SalesPerformanceList?.YEARLY) {
      const header = tHead1
        ?.map((a) => a?.text)
        ?.filter(
          (id): id is string => typeof id === "string" && id !== undefined
        );
      setSelectedRows(header);
    }
  }, [selection]);

  const handleApply = () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    }
  
    if (selection === SalesPerformanceList?.MONTHLY) {
      if (
        yearAndMonth === null ||
        (yearAndMonth !== null &&
          yearAndMonth?.getFullYear()?.toString() === "" &&
          yearAndMonth?.getMonth()?.toString() === "")
      ) {
        toast("Select month and year", ToastTypes?.ERROR);
        error = true;
      }
    }

    // if (selection === SalesPerformanceList?.MONTHLY) {
    const yr = yearAndMonth?.getFullYear();
    const mon = month[yearAndMonth?.getMonth()];

    

    var MgetData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: yr,
      month: mon,
      limit: limit?.toString(),
      offset: offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };
    // } else {
    var YgetData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      limit: limit?.toString(),
      offset: offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };
    // }

    if (
      error === false &&
      MgetData !== undefined &&
      YgetData?.limit !== "" &&
      YgetData?.offset !== ""
    ) {
      if (selection === SalesPerformanceList?.MONTHLY) {
        if (pag === false) {
          setLoader(true);
        }
        api
          .post<APIResponse<{ records: MonthlyFootfallDailyFlowReportType[] }>>(
            `kpi/footfall/monthwiseDailyFlow`,
            MgetData,
            config
          )
          .then((response) => {
            if (response?.status === 200 && response?.data?.data) {
              const result = response?.data?.data?.records;

              
              setLoader(false);
            setPag(true);
              setMonthlyFootfallDailyFlowData(result);
              setCondition(false)
              if(authUser){
                const logProps1 = {
                  action: 'Apply',
                  event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked (${selection}) | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
                };
                UserLog(logProps1)
              }
            
            }
          })
          .catch((error) => {});
      } else if (selection === SalesPerformanceList?.YEARLY) {
        if (pag === false) {
          setLoader(true);
        }
        api
          .post<APIResponse<{ records: YearlyFootfallDailyFlowReportType[] }>>(
            `kpi/footfall/yearwiseDailyFlow`,
            YgetData,
            config
          )
          .then((response) => {
            if (response?.status === 200 && response?.data?.data) {
              const result = response?.data?.data?.records;

              setLoader(false);
              setPag(true);
              setYearlyFootfallDailyFlowData(result);
              setCondition(false)
              if(authUser){
                const logProps1 = {
                  action: 'Apply',
                  event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked (${selection}) | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
                };
                UserLog(logProps1)
              }
              // calculateRange(limit)
            }
          })
          .catch((error) => {});
      }
    } else {
      setMonthlyFootfallDailyFlowData([]);
      setYearlyFootfallDailyFlowData([]);
      setLoader(false);
      setPag(true);
      setCondition(false)
    }
  };

  
  const handlePag = () => {
    setPag(true);
  };


  useEffect(() => {
    if (portfolios !== "" && fileLoader === false) {
      handleApply();
    } 
  }, [portfolios]);

  const handleCsvDownload = async () => {
    setFileLoader(true);
    const csvData = await fetchDataForDownload();
    if (
      csvData[0]?.record?.length !== 0 &&
      csvData[0]?.record?.length !== undefined
    ) {
      const d =
        selection === SalesPerformanceList?.MONTHLY
          ? {
              ...getMonthlyDownloadData(
                csvData as MonthlyFootfallDailyFlowReportType[]
              ),
            }
          : {
              ...getYearlyDownloadData(
                csvData as YearlyFootfallDailyFlowReportType[]
              ),
            };
      const filteredHead = d?.thead
        ?.map((a) => {
          const foundObject = selectedRows
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);

      const csvHead = filteredHead;
      const csvBody = d?.tbody;

      const head = [csvHead?.map((h) => h?.text || "") || []];
      const body =
        csvBody?.map((tr, i) => {
          return (
            csvHead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const rows = [...head, ...body];
      const props = {
        rows: rows,
        fileName:
          selection === SalesPerformanceList?.MONTHLY
            ? "Monthly Footfall Daily Flow"
            : "Yearly Footfall Daily Flow",
      };
      CSVdownload(props);
      setFileLoader(false);
      if(authUser){
        const logProps1 = {
          action: 'Csv',
          event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Csv Clicked (${selection}) | Export Status: Success | Data Status: Success`
        };
        UserLog(logProps1)
      }
    } else {
      setFileLoader(false);
      if(authUser){
        const logProps1 = {
          action: 'Csv',
          event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Csv Clicked (${selection}) | Export Status: Success | Data Status: Empty`
        };
        UserLog(logProps1)
      }
    }
    setFileLoader(false);
  };

  const handlePdfDownload = async () => {
    setFileLoader(true);
    const pdfData = await fetchDataForDownload();
    if (
      pdfData[0]?.record?.length !== 0 &&
      pdfData[0]?.record?.length !== undefined
    ) {
      const d =
        selection === SalesPerformanceList?.MONTHLY
          ? {
              ...getMonthlyDownloadData(
                pdfData as MonthlyFootfallDailyFlowReportType[]
              ),
            }
          : {
              ...getYearlyDownloadData(
                pdfData as YearlyFootfallDailyFlowReportType[]
              ),
            };
      const filteredHead = d?.thead
        ?.map((a) => {
          const foundObject = selectedRows
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);

      const thead = filteredHead;
      const tbody = d?.tbody;

      const head = [thead?.map((h) => h?.text || "") || []];
      const body =
        tbody?.map((tr, i) => {
          return (
            thead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const props = {
        head: head,
        body: body,
        fileName:
          selection === SalesPerformanceList?.MONTHLY
            ? "Monthly Footfall Daily Flow"
            : "Yearly Footfall Daily Flow",
        title:
          selection === SalesPerformanceList?.MONTHLY
            ? "Monthly Footfall Daily Flow"
            : "Yearly Footfall Daily Flow",
      };
      handleDownloadPDF(props);
      setFileLoader(false);
      if(authUser){
        const logProps1 = {
          action: 'Pdf',
          event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Pdf Clicked (${selection}) | Export Status: Success | Data Status: Success`
        };
        UserLog(logProps1)
      }
    } else {
      setFileLoader(false);
      if(authUser){
        const logProps1 = {
          action: 'Pdf',
          event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Pdf Clicked (${selection}) | Export Status: Success | Data Status: Empty`
        };
        UserLog(logProps1)
      }
    }
    setFileLoader(false);
  };

  const getYearlyTableData = () => {
    var tableHead: Thead[] = [
      { id: "Center", children: "Center", text: "Center" },
      // { id: "Building", children: "Building", text: "Building" },
      { id: "Year", children: "Year", text: "Year" },
      { id: "Count", children: "Count", text: "Count" },
    ];
    var tableBody: Tbody[][] = [];

    let data = yearlyFootfallDailyFlowData;

    data?.forEach((d, i) => {
      siteOption
        ?.filter((ss) => ss?.pfid?.toString() === d?.portfolio?.toString())
        ?.forEach((s) => {
          d?.record
            ?.filter((r) => r?.centerid?.toString() === s?.id?.toString())
            ?.forEach((item) => {
              const centerObj = siteOption?.find(
                (s) => s?.id?.toString() === item?.centerid?.toString()
              );
              // const buildingObj = buildingOption?.find(
              //   (b) =>
              //     b?.buildingid?.toString() === item?.buildingid?.toString()
              // );
              var tBody: Tbody[] = [];
              tBody?.push(
                {
                  id: nanoid(),
                  theadId: "Center",
                  children: centerObj?.name,
                  text: centerObj?.name,
                },
                // {
                //   id: nanoid(),
                //   theadId: "Building",
                //   children: buildingObj?.buildingname,
                //   text: buildingObj?.buildingname,
                // },
                {
                  id: nanoid(),
                  theadId: "Year",
                  children: item?.transyear,
                  text: item?.transyear?.toString(),
                },
                {
                  id: nanoid(),
                  theadId: "Count",
                  children: item?.tcount,
                  text: item?.tcount?.toString(),
                }
              );
              tableBody?.push(tBody);
            });
        });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  const getMonthlyTableData = () => {
    var tableHead: Thead[] = [
      { id: "Center", children: "Center", text: "Center" },
      // { id: "Building", children: "Building", text: "Building" },
      { id: "Date", children: "Date", text: "Date" },
      { id: "Count", children: "Count", text: "Count" },
    ];

    var tableBody: Tbody[][] = [];

    let data = monthlyFootfallDailyFlowData;

    data?.forEach((d, i) => {
      siteOption
        ?.filter((ss) => ss?.pfid?.toString() === d?.portfolio?.toString())
        ?.forEach((s) => {
          d?.record
            ?.filter((r) => r?.centerid?.toString() === s?.id?.toString())
            ?.forEach((item) => {
              const centerObj = siteOption?.find(
                (s) => s?.id?.toString() === item?.centerid?.toString()
              );
              // const buildingObj = buildingOption?.find(
              //   (b) =>
              //     b?.buildingid?.toString() === item?.buildingid?.toString()
              // );
              var tBody: Tbody[] = [];
              tBody?.push(
                {
                  id: nanoid(),
                  theadId: "Center",
                  children: centerObj?.name,
                  text: centerObj?.name,
                },
                // {
                //   id: nanoid(),
                //   theadId: "Building",
                //   children: buildingObj?.buildingname,
                //   text: buildingObj?.buildingname,
                // },
                {
                  id: nanoid(),
                  theadId: "Date",
                  children: item?.date,
                  text: item?.date?.toString(),
                },
                {
                  id: nanoid(),
                  theadId: "Count",
                  children: item?.tcount,
                  text: item?.tcount?.toString(),
                }
              );
              tableBody?.push(tBody);
            });
        });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  const portfolio = useMemo<number[]>(() => {
    return portfolios !== "" ? [parseInt(portfolios)] : [];
  }, [portfolios]);

  const site = useMemo<string[]>(() => {
    if (authUserSiteId) {
      return authUserSiteId?.split(",")?.map((s) => {
        return s?.toString();
      });
    } else {
      return [];
    }
  }, [authUserSiteId]);

  const brand = useMemo<number[]>(() => {
    if (brands !== "") {
      return brands !== "" ? [parseInt(brands)] : [];
    } else return []; //bcz no brand filter
  }, [brands]);

  const category = useMemo<number[]>(() => {
    return categories !== "" ? [parseInt(categories)] : [];
  }, [categories]);

  const subCategory = useMemo<number[]>(() => {
    return subCategories !== "" ? [parseInt(subCategories)] : [];
  }, [subCategories]);

  useEffect(() => {
    setOffset(0);
  }, [yearAndMonth]);


  useEffect(()=>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
    }
},[portfolioOption,selectedOption])

useEffect(()=>{
  setLocation(selectedOption.location? selectedOption.location:'')
  const b = localityOption.filter((a)=>a?.area?.toString()===selectedOption.location?.toString())
  if (b?.length > 0 && b[0]?.id !== undefined) {
    const val: DropDownOption = {
      value: b[0]?.id, 
      label: b[0]?.area,
      imgUrl:'', 
    };
    setLocationDrop([val]);
  }
  },[localityOption,selectedOption])


  useEffect(() => {
    let sid = siteData[0] && siteData[0]?.id ? siteData[0]?.id?.toString() : "";
    setSites(selectedOption?.site ? selectedOption?.site : sid);
  }, [siteData, selectedOption]);

  useEffect(() => {
    setBrands(selectedOption?.brand);
  }, [selectedOption]);

  useEffect(()=>{    
    if(selectedOption?.isOutletUser){
      setDisableLocality(true);
    }
    else{
      setDisableLocality(false);
    }
  },[authUser,selectedOption]);

  useEffect(() => {
    if (selectedOption?.category) setCategories(selectedOption?.category);
  }, [selectedOption]);

  useEffect(() => {
    if (selectedOption?.subCategory)
      setSubCategories(selectedOption?.subCategory);
  }, [selectedOption]);

  useEffect(() => {
    var range = [];
    var num = Math?.ceil(length / limit);
    // let i = 1;

    for (let i = 1; i <= num; i++) {
      range?.push(i);
    }
    setRange(range);
  }, [length, limit]);

  useEffect(() => {
    if (sites !== ""&&selectedOption.isOutletUser===true) {
      let siteCurrencyObject = siteOption?.find(
        (s) => s?.id?.toString() === sites?.toString()
      );
      setValueIn(
        siteCurrencyObject?.currencycode +
          " | " +
          siteCurrencyObject?.valuecaption
      );
    } 
    else if(portfolios !== ""&&selectedOption.isOutletUser===false){
      let portfolioCurrencyObject = portfolioOption?.find(
        (s) => s?.id?.toString() === portfolios?.toString()
      );
      setValueIn(
        portfolioCurrencyObject?.reportingcurrency +
          " | " +
          portfolioCurrencyObject?.valuecaption
      );
    }
    else setValueIn("");
  }, [sites, siteOption,selectedOption]);

  useEffect(() => {
    if (
      selection === SalesPerformanceList?.MONTHLY &&
      monthlyFootfallDailyFlowData?.length > 0
    ) {
      setLength(
        monthlyFootfallDailyFlowData[0]?.count
          ? monthlyFootfallDailyFlowData[0]?.count
          : 0
      );
    } else if (
      selection === SalesPerformanceList?.YEARLY &&
      yearlyFootfallDailyFlowData?.length > 0
    ) {
      setLength(
        yearlyFootfallDailyFlowData[0]?.count
          ? yearlyFootfallDailyFlowData[0]?.count
          : 0
      );
    }
  }, [monthlyFootfallDailyFlowData, yearlyFootfallDailyFlowData, selection]);

  useEffect(() => {
    var getData = {
      portfolio: portfolio,
    };

    if (portfolio?.length > 0 && getData !== undefined) {
      api
        .post<
          APIResponse<{ records: CatSubCatCompanyWithBrandRelationDataType[] }>
        >(`filter/catSubcatCompanyRelationWithBrand`, getData, config)
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setCatSubCatCompanyWithBrandRelationData(result);
          }
        })
        .catch((error) => {});
    } else {
      setCatSubCatCompanyWithBrandRelationData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolio]);

  const colors = [
    COLORS?.COLOR1,
    COLORS?.COLOR2,
    COLORS?.COLOR3,
    COLORS?.COLOR4,
    COLORS?.COLOR5,
    COLORS?.COLOR6,
    COLORS?.COLOR7,
    COLORS?.COLOR8,
  ];
  
  useEffect(()=>{
    if(authUser){
    const logProps1 = {
      action:`Visit`,
      event: `${pageName?.pathname?.replace("\\", " ")} page | Visited `
    };
    UserLog(logProps1)
  }
  },[])


  return (
    <UserLayout>
      <div className="card background-transparent p-1">
        <div className="row">
          <div
            className="col-lg-4 wow fadeInLeft ps-0"
          >
            <h4 className="b-title">Daily Flow</h4>
          </div>

          <div className="col-lg-8 wow fadeInRight">
            <div className="row">
              <div className="col-sm-6 col-md-4 col-lg-3">
                {/* <FormInput2
                  name="Portfolio"
                  label=""
                  labelClassName="required"
                  value={portfolios}
                  onChange={handlePortfolioChange}
                  placeholder="Select"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select</option>
                  {portfolioData?.map((p, i) => {
                    return (
                      <Option value={p?.id} key={i}>
                        {p?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                  {/* <SingleSelect
                  options={[
                    defaultPortfolio,
                    ...portfolioData?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: s?.logourl,
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={portfoliosOption}
                  setSelectedOptions={handlePortfolioChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Portfolio"
                  // filterText=""
                /> */}


                  <SingleSelect1
                      options={portfolioData.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={portfolioDrop}
                      setSelectedOptions={handlePortfolioDrop}
                      placeHolder="Select Portfolio"
                      onClear={handleClearPortfolio}
                      disabled = {disableLocality}
                    />
              </div>
              

              <div className="col-sm-6 col-md-4 col-lg-3">
              {/* <FormInput2
                  name="Location"
                  label=""
                  labelClassName="required"
                  value={location}
                  onChange={handleLocationChange}
                  placeholder="Select Locality"
                  containerClass="mb-1"
                  disabled={disableLocality}
                  type="select"
                >
                  <option value="">Select Locality</option>
                  {localityOption?.map((s, i) => {
                    return (
                      <Option value={s?.area} key={i}>
                        {s?.area}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                 {/* <SingleSelect
                  options={[
                    defaultLocation,
                    ...localityOption?.sort(function (a, b) {
                      if (a?.area < b?.area) {
                        return -1;
                      }
                      if (a?.area > b?.area) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.area,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={locationOption}
                  setSelectedOptions={handleLocationChange}
                  disabled={disableLocality}
                  placeHolder="Select Locality"
                  // filterText=""
                /> */}

                <SingleSelect1
                      options={localityOption.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.area?c?.area:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={locationDrop}
                      setSelectedOptions={handleLocationDrop}
                      placeHolder="Select Locality"
                      onClear={handleClearLocation}
                      disabled = {disableLocality}
                    />
              </div>
            </div>

            
          </div>
        </div>
      </div>
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3 widget_div" onMouseEnter={() => setButtonVisible(true)} onMouseLeave={() => setButtonVisible(false)}>
                {(<button type="button" className="expandIconBtn" onClick={showExpandModalHandler} ><i><FontAwesomeIcon icon={faWindowMaximize} size="lg" title="Open in Popup"/></i></button>)}
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-start">
                        <h5 className="header-title mt-1">
                          <img src={chartIcon} alt="icon"></img> Footfall Daily
                          Flow
                        </h5>
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-end hstack gap-1">
                        {selection === SalesPerformanceList?.MONTHLY && (
                          <div
                            className="col-sm-6 col-md-6 col-lg-6"
                            style={{ width: "133px" }}
                          >
                            <div className="DateContainer">
                              <span className="dateInput">
                                <ReactDatePicker
                                  id="DatePicker"
                                  className="text-center fw-bold form-control"
                                  selected={yearAndMonth}
                                  onChange={handleDateChange}
                                  showMonthYearPicker
                                  dateFormat="MM/yyyy"
                                  yearItemNumber={8}
                                />
                              </span>
                              <span className="icon">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                                    fill="#6C757D"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          </div>
                        )}
                        
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleApply}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="m-0 my-2 p-0 hr" />
                  <div className="col-lg-12 col-sm-12 text-end">
                    <button
                      type="button"
                      onClick={monthlyHandler}
                      className={`m-1 btn btn-xs ${
                        selection === "monthly"
                          ? "btn-sales btn-mom onSelect"
                          : "btn-sales btn-mom text-black"
                      }`}
                    >
                      MOM
                    </button>
                    <button
                      type="button"
                      onClick={yearlyHandler}
                      className={`m-1 btn btn-xs ${
                        selection === "yearly"
                          ? "btn-sales btn-yoy onSelect"
                          : "btn-sales btn-yoy text-black"
                      }`}
                    >
                      YOY
                    </button>
                  </div>

                  {selection === SalesPerformanceList?.MONTHLY &&
                    (monthlyFootfallDailyFlowData[0]?.record?.length !==
                      undefined &&
                    monthlyFootfallDailyFlowData[0]?.record?.length > 0 ? (
                      <LineChart
                        datasets={(() => {
                          let mdata: { name: string; data: number[] }[] = [];
                          monthlyFootfallDailyFlowData?.forEach((y, i) => {

                            siteOption
                              ?.filter(
                                (ss) =>
                                  ss?.pfid?.toString() ===
                                  y?.portfolio?.toString()
                              )
                              ?.forEach((s) => {
                                let d1 = y?.record?.filter(
                                  (sw) =>
                                    sw?.centerid?.toString() ===
                                    s?.id?.toString()
                                );

                                const selectedYears = [
                                  yearAndMonth?.getFullYear(),
                                  yearAndMonth?.getFullYear() - 1,
                                ];

                                let mon = yearAndMonth?.getMonth();

                                if (month[yearAndMonth?.getMonth()] !== "01") {
                                  selectedYears?.forEach((yr, yi) => {
                                    var yrs = d1?.map((d) => d?.transyear);
                                    if (yrs?.includes(yr)) {
                                      if (yi === 0) {
                                        let data1: number[] = [];
                                        let data2: number[] = [];
                                        let arr = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth === mon + 1
                                          );
                                        days?.forEach((d) => {
                                          let obj = arr?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data1?.push(
                                                obj?.tcount
                                                  ? parseFloat(obj?.tcount!)
                                                  : 0
                                              )
                                            : data1?.push(0);
                                        });

                                        let isEmpty: string[] = [];
                                        data1?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty?.push("true");
                                          else isEmpty?.push("false");
                                        });

                                        if (
                                          data1?.length > 0 &&
                                          isEmpty?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data1,
                                          });
                                        }
                                        let arr2 = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth !== mon + 1
                                          );
                                        days?.forEach((d) => {
                                          let obj = arr2?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data2?.push(
                                                obj?.tcount
                                                  ? parseFloat(obj?.tcount!)
                                                  : 0
                                              )
                                            : data2?.push(0);
                                        });

                                        let isEmpty2: string[] = [];
                                        data2?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty2?.push("true");
                                          else isEmpty2?.push("false");
                                        });

                                        if (
                                          data2?.length > 0 &&
                                          isEmpty2?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr2[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data2,
                                          });
                                        }
                                      } else {
                                        let data2: number[] = [];

                                        let arr = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth === mon + 1
                                          );
                                        days?.forEach((d) => {
                                          let obj = arr?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data2?.push(
                                                obj?.tcount
                                                  ? parseFloat(obj?.tcount!)
                                                  : 0
                                              )
                                            : data2?.push(0);
                                        });

                                        let isEmpty2: string[] = [];
                                        data2?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty2?.push("true");
                                          else isEmpty2?.push("false");
                                        });

                                        if (
                                          data2?.length > 0 &&
                                          isEmpty2?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data2,
                                          });
                                        }
                                      }
                                    }
                                  });
                                } else if (
                                  month[yearAndMonth?.getMonth()] === "01"
                                ) {
                                  selectedYears?.forEach((yr, yi) => {
                                    var yrs = d1?.map((d) => d?.transyear);
                                    if (yrs?.includes(yr)) {
                                      if (yi === 1) {
                                        let data1: number[] = [];
                                        let data2: number[] = [];
                                        let arr = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth === mon + 1
                                          );

                                        days?.forEach((d) => {
                                          let obj = arr?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data1?.push(
                                                obj?.tcount
                                                  ? parseFloat(obj?.tcount!)
                                                  : 0
                                              )
                                            : data1?.push(0);
                                        });

                                        let isEmpty: string[] = [];
                                        data1?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty?.push("true");
                                          else isEmpty?.push("false");
                                        });

                                        if (
                                          data1?.length > 0 &&
                                          isEmpty?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data1,
                                          });
                                        }

                                        let arr2 = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth !== mon + 1
                                          );
                                        if (arr2?.length > 0) {
                                          days?.forEach((d) => {
                                            let obj = arr2?.find(
                                              (ad) =>
                                                new Date(ad?.date)?.getDate() ===
                                                parseInt(d)
                                            );
                                            obj
                                              ? data2?.push(
                                                  obj?.tcount
                                                    ? parseFloat(obj?.tcount!)
                                                    : 0
                                                )
                                              : data2?.push(0);
                                          });

                                          let isEmpty2: string[] = [];
                                          data2?.forEach((d2) => {
                                            if (d2 !== 0) isEmpty2?.push("true");
                                            else isEmpty2?.push("false");
                                          });

                                          if (
                                            data2?.length > 0 &&
                                            isEmpty2?.includes("true")
                                          ) {
                                            mdata?.push({
                                              name:
                                                s?.name +
                                                "-" +
                                                arr2[0]?.transmonth +
                                                "/" +
                                                yr,
                                              data: data2,
                                            });
                                          }
                                        }
                                      } else {
                                        let data2: number[] = [];

                                        let arr = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth === mon + 1
                                          );

                                        days?.forEach((d) => {
                                          let obj = arr?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data2?.push(
                                                obj?.tcount
                                                  ? parseFloat(obj?.tcount!)
                                                  : 0
                                              )
                                            : data2?.push(0);
                                        });

                                        let isEmpty2: string[] = [];
                                        data2?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty2?.push("true");
                                          else isEmpty2?.push("false");
                                        });

                                        if (
                                          data2?.length > 0 &&
                                          isEmpty2?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data2,
                                          });
                                        }
                                      }
                                    }
                                  });
                                }
                              });
                          });

                          return mdata;
                        })()}
                        labels={days}
                        colors={[
                          colors[0],
                          colors[1],
                          colors[2],
                          colors[3],
                          colors[4],
                          colors[5],
                          colors[6],
                          colors[7],
                        ]}
                        title={(() => {
                          const txt = `Footfall Daily Flow - MOM`;
                          return txt;
                        })()}
                        subtitle={(() => {
                          let subtxt = `\u3010Company\u3011: ${pname}`;
                          if (location) {
                            subtxt += `\u3010Locality\u3011: ${location}`;
                          }
                          subtxt += ` \u3010Year\u3011: ${yearAndMonth?.getFullYear()}`;
                          subtxt += ` \u3010Month\u3011: ${
                            yearAndMonth?.getMonth() + 1
                          }`;
                          return subtxt;
                        })()}
                        exportfilename={"FootfallDailyFlow-MOM"}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                  {selection === SalesPerformanceList?.YEARLY &&
                    (yearlyFootfallDailyFlowData[0]?.record?.length > 0 &&
                    yearlyFootfallDailyFlowData[0]?.record?.length !==
                      undefined ? (
                      <LineChart
                        datasets={(() => {
                          let ydata: { name: string; data: number[] }[] = [];
                          yearlyFootfallDailyFlowData?.forEach((y, i) => {

                            siteOption
                              ?.filter(
                                (ss) =>
                                  ss?.pfid?.toString() ===
                                  y?.portfolio?.toString()
                              )
                              ?.filter((s2) => {
                                if (sites) return s2?.id?.toString() === sites;
                                else return s2;
                              })
                              ?.forEach((s) => {
                                let data2: number[] = [];
                                let d1 = y?.record?.filter(
                                  (sw) =>
                                    sw?.centerid?.toString() === s?.id?.toString()
                                );

                                yearDropDown?.sort()?.forEach((yr) => {
                                  var yrs = d1?.map((d) => d?.transyear);
                                  if (yrs?.includes(yr)) {
                                    let obj = d1?.find(
                                      (f) =>
                                        f?.transyear?.toString() ===
                                        yr?.toString()
                                    );
                                    data2?.push(
                                      obj?.tcount ? parseFloat(obj?.tcount!) : 0
                                    );
                                  } else data2?.push(0);
                                });

                                let isEmpty: string[] = [];
                                data2?.forEach((d2) => {
                                  if (d2 !== 0) isEmpty?.push("true");
                                  else isEmpty?.push("false");
                                });
                                if (
                                  data2?.length > 0 &&
                                  isEmpty?.includes("true")
                                ) {
                                  ydata?.push({
                                    name: s?.name,
                                    data: data2,
                                  });
                                }
                              });
                          });
                          return ydata;
                        })()}
                        labels={
                          yearDropDown?.map((y) => y?.toString())?.sort() || []
                        }
                        colors={[
                          colors[0],
                          colors[1],
                          colors[2],
                          colors[3],
                          colors[4],
                          colors[5],
                          colors[6],
                          colors[7],
                        ]}
                        title={(() => {
                          const txt = `Footfall Daily Flow - YOY`;
                          return txt;
                        })()}
                        subtitle={(() => {
                          let subtxt = `\u3010Company\u3011: ${pname}`;
                          
                          if (location) {
                            subtxt += `\u3010Locality\u3011: ${location}`;
                          }
                          subtxt += ` \u3010Period\u3011: ${
                            year?.getFullYear() - 2
                          } - ${year?.getFullYear()}`;

                          return subtxt;
                        })()}
                        exportfilename={"FootfallDailyFlow-YOY"}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3">
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-start">
                        <h5 className="header-title mt-1">
                          <img src={tableIcon} alt="icon"></img>
                          {selection === SalesPerformanceList?.YEARLY
                            ? "Yearly"
                            : "Monthly"}{" "}
                          Footfall Daily Flow
                        </h5>
                      </div>
                    </div>
                  </div>

                  {selection === SalesPerformanceList?.MONTHLY && (
                    <TransactionTable
                      data={[]}
                      {...getMonthlyTableData()}
                      title=""
                      downloadCSV={true}
                      downloadPDF={true}
                      fileName="Monthly Footfall Daily Flow"
                      limit={limit}
                      setOffset={setOffset}
                      onClickCSV={handleCsvDownload}
                      onClickPDF={handlePdfDownload}
                      range={range}
                      fLoader={fileLoader}
                      onSelectedRowsChange={handleSelectedRowsChange}
                      onPageNoChange={pag && (offset > 0||condition) ? handleApply : undefined}
                      handlePag={pag ? handlePag : undefined}
                      onOffchange={handleOff}
                    />
                  )}
                  {selection === SalesPerformanceList?.YEARLY && (
                    <TransactionTable
                      data={[]}
                      {...getYearlyTableData()}
                      title=""
                      downloadCSV={true}
                      downloadPDF={true}
                      fileName="Yearly Footfall Daily Flow"
                      limit={limit}
                      setOffset={setOffset}
                      onClickCSV={handleCsvDownload}
                      onClickPDF={handlePdfDownload}
                      range={range}
                      fLoader={fileLoader}
                      // valueInString={valueIn}
                      onSelectedRowsChange={handleSelectedRowsChange}
                      onPageNoChange={pag && (offset > 0||condition) ? handleApply : undefined}
                      handlePag={pag ? handlePag : undefined}
                      onOffchange={handleOff}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        
          {showModal && (
        <Modal
        headerText={"Footfall Daily Flow"}
        visible={showModal}
        onClose={() => setShowModal(false)}
        size="xl"
        centered
        classname="widget-container-single" > 
		
    <div className="card-body">
                  

                  {selection === SalesPerformanceList?.MONTHLY &&
                    (monthlyFootfallDailyFlowData[0]?.record?.length !==
                      undefined &&
                    monthlyFootfallDailyFlowData[0]?.record?.length > 0 ? (
                      <LineChart
                        datasets={(() => {
                          let mdata: { name: string; data: number[] }[] = [];
                          monthlyFootfallDailyFlowData?.forEach((y, i) => {
                            siteOption
                              ?.filter(
                                (ss) =>
                                  ss?.pfid?.toString() ===
                                  y?.portfolio?.toString()
                              )
                              ?.forEach((s) => {
                                let d1 = y?.record?.filter(
                                  (sw) =>
                                    sw?.centerid?.toString() === s?.id?.toString()
                                );

                                const selectedYears = [
                                  yearAndMonth?.getFullYear(),
                                  yearAndMonth?.getFullYear() - 1,
                                ];

                                let mon = yearAndMonth?.getMonth();

                                if (month[yearAndMonth?.getMonth()] !== "01") {
                                  selectedYears?.forEach((yr, yi) => {
                                    var yrs = d1?.map((d) => d?.transyear);
                                    if (yrs?.includes(yr)) {
                                      if (yi === 0) {
                                        let data1: number[] = [];
                                        let data2: number[] = [];
                                        let arr = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth === mon + 1
                                          );
                                        days?.forEach((d) => {
                                          let obj = arr?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data1?.push(
                                                parseFloat(obj?.tcount!)
                                              )
                                            : data1?.push(0);
                                        });

                                        let isEmpty: string[] = [];
                                        data1?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty?.push("true");
                                          else isEmpty?.push("false");
                                        });

                                        if (
                                          data1?.length > 0 &&
                                          isEmpty?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data1,
                                          });
                                        }
                                        let arr2 = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth !== mon + 1
                                          );
                                        days?.forEach((d) => {
                                          let obj = arr2?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data2?.push(
                                                parseFloat(obj?.tcount!)
                                              )
                                            : data2?.push(0);
                                        });

                                        let isEmpty2: string[] = [];
                                        data2?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty2?.push("true");
                                          else isEmpty2?.push("false");
                                        });

                                        if (
                                          data2?.length > 0 &&
                                          isEmpty2?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr2[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data2,
                                          });
                                        }
                                      } else {
                                        let data2: number[] = [];

                                        let arr = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth === mon + 1
                                          );
                                        days?.forEach((d) => {
                                          let obj = arr?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data2?.push(
                                                parseFloat(obj?.tcount!)
                                              )
                                            : data2?.push(0);
                                        });

                                        let isEmpty2: string[] = [];
                                        data2?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty2?.push("true");
                                          else isEmpty2?.push("false");
                                        });

                                        if (
                                          data2?.length > 0 &&
                                          isEmpty2?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data2,
                                          });
                                        }
                                      }
                                    }
                                  });
                                } else if (
                                  month[yearAndMonth?.getMonth()] === "01"
                                ) {
                                  selectedYears?.forEach((yr, yi) => {
                                    var yrs = d1?.map((d) => d?.transyear);
                                    if (yrs?.includes(yr)) {
                                      if (yi === 1) {
                                        let data1: number[] = [];
                                        let data2: number[] = [];
                                        let arr = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth === mon + 1
                                          );

                                        days?.forEach((d) => {
                                          let obj = arr?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data1?.push(
                                                parseFloat(obj?.tcount!)
                                              )
                                            : data1?.push(0);
                                        });

                                        let isEmpty: string[] = [];
                                        data1?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty?.push("true");
                                          else isEmpty?.push("false");
                                        });

                                        if (
                                          data1?.length > 0 &&
                                          isEmpty?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data1,
                                          });
                                        }

                                        let arr2 = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth !== mon + 1
                                          );
                                        if (arr2?.length > 0) {
                                          days?.forEach((d) => {
                                            let obj = arr2?.find(
                                              (ad) =>
                                                new Date(ad?.date)?.getDate() ===
                                                parseInt(d)
                                            );
                                            obj
                                              ? data2?.push(
                                                  parseFloat(obj?.tcount!)
                                                )
                                              : data2?.push(0);
                                          });

                                          let isEmpty2: string[] = [];
                                          data2?.forEach((d2) => {
                                            if (d2 !== 0) isEmpty2?.push("true");
                                            else isEmpty2?.push("false");
                                          });

                                          if (
                                            data2?.length > 0 &&
                                            isEmpty2?.includes("true")
                                          ) {
                                            mdata?.push({
                                              name:
                                                s?.name +
                                                "-" +
                                                arr2[0]?.transmonth +
                                                "/" +
                                                yr,
                                              data: data2,
                                            });
                                          }
                                        }
                                      } else {
                                        let data2: number[] = [];

                                        let arr = d1
                                          ?.filter(
                                            (f) =>
                                              f?.transyear?.toString() ===
                                              yr?.toString()
                                          )
                                          ?.filter(
                                            (m) => m?.transmonth === mon + 1
                                          );

                                        days?.forEach((d) => {
                                          let obj = arr?.find(
                                            (ad) =>
                                              new Date(ad?.date)?.getDate() ===
                                              parseInt(d)
                                          );
                                          obj
                                            ? data2?.push(
                                                parseFloat(obj?.tcount!)
                                              )
                                            : data2?.push(0);
                                        });

                                        let isEmpty2: string[] = [];
                                        data2?.forEach((d2) => {
                                          if (d2 !== 0) isEmpty2?.push("true");
                                          else isEmpty2?.push("false");
                                        });

                                        if (
                                          data2?.length > 0 &&
                                          isEmpty2?.includes("true")
                                        ) {
                                          mdata?.push({
                                            name:
                                              s?.name +
                                              "-" +
                                              arr[0]?.transmonth +
                                              "/" +
                                              yr,
                                            data: data2,
                                          });
                                        }
                                      }
                                    }
                                  });
                                }
                              });
                          });

                          return mdata;
                        })()}
                        labels={days}
                        colors={[
                          colors[0],
                          colors[1],
                          colors[2],
                          colors[3],
                          colors[4],
                          colors[5],
                          colors[6],
                          colors[7],
                        ]}
                        title={(() => {
                          const txt = `Footfall Daily Flow - MOM`;
                          return txt;
                        })()}
                        subtitle={(() => {
                          let subtxt = `\u3010Company\u3011: ${pname}`;
                          
                          if (location) {
                            subtxt += `\u3010Locality\u3011: ${location}`;
                          }
                          subtxt += ` \u3010Year\u3011: ${yearAndMonth?.getFullYear()}`;
                          subtxt += ` \u3010Month\u3011: ${
                            yearAndMonth?.getMonth() + 1
                          }`;
                          return subtxt;
                        })()}
                        exportfilename={"FootfallDailyFlow-MOM"}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                  {selection === SalesPerformanceList?.YEARLY &&
                    (yearlyFootfallDailyFlowData[0]?.record?.length > 0 &&
                    yearlyFootfallDailyFlowData[0]?.record?.length !==
                      undefined ? (
                      <LineChart
                        datasets={(() => {
                          let ydata: { name: string; data: number[] }[] = [];
                          yearlyFootfallDailyFlowData?.forEach((y, i) => {

                            siteOption
                              ?.filter(
                                (ss) =>
                                  ss?.pfid?.toString() ===
                                  y?.portfolio?.toString()
                              )
                              ?.filter((s2) => {
                                if (sites) return s2?.id?.toString() === sites;
                                else return s2;
                              })
                              ?.forEach((s) => {
                                let data2: number[] = [];
                                let d1 = y?.record?.filter(
                                  (sw) =>
                                    sw?.centerid?.toString() === s?.id?.toString()
                                );

                                yearDropDown?.sort()?.forEach((yr) => {
                                  var yrs = d1?.map((d) => d?.transyear);
                                  if (yrs?.includes(yr)) {
                                    let obj = d1?.find(
                                      (f) =>
                                        f?.transyear?.toString() ===
                                        yr?.toString()
                                    );
                                    data2?.push(parseFloat(obj?.tcount!));
                                  } else data2?.push(0);
                                });

                                let isEmpty: string[] = [];
                                data2?.forEach((d2) => {
                                  if (d2 !== 0) isEmpty?.push("true");
                                  else isEmpty?.push("false");
                                });
                                if (
                                  data2?.length > 0 &&
                                  isEmpty?.includes("true")
                                ) {
                                  ydata?.push({
                                    name: s?.name,
                                    data: data2,
                                  });
                                }
                              });
                          });
                          return ydata;
                        })()}
                        labels={
                          yearDropDown?.map((y) => y?.toString())?.sort() || []
                        }
                        colors={[
                          colors[0],
                          colors[1],
                          colors[2],
                          colors[3],
                          colors[4],
                          colors[5],
                          colors[6],
                          colors[7],
                        ]}
                        title={(() => {
                          const txt = `Footfall Daily Flow - YOY`;
                          return txt;
                        })()}
                        subtitle={(() => {
                          let subtxt = `\u3010Company\u3011: ${pname}`;
                          if (location) {
                            subtxt += `\u3010Locality\u3011: ${location}`;
                          }
                          subtxt += ` \u3010Period\u3011: ${
                            year?.getFullYear() - 2
                          } - ${year?.getFullYear()}`;

                          return subtxt;
                        })()}
                        exportfilename={"FootfallDailyFlow-YOY"}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                </div>
		
		</Modal>)}
        </>
      )}
    </UserLayout>
  );
};
export default FootfallDailyFlowReport;
